import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

import { useStyles } from '../checkoutDrawer.styles';

function PromoCode ({ form, setField, handleApplyPromo, handleRemovePromo, formatPrice }) {
    const classes = useStyles();

    return (
        <div>
            <p className={classes.sectionLabel}>Promo code</p>
            {form.promoApplied ? (
                <div className={classes.promoSuccess} aria-live="polite">
                    <span className={classes.promoSuccessText}>✓ {form.promo.trim().toUpperCase()} applied · {form.manifest && form.manifest.currentBillingManifest ? `${formatPrice(form.manifest.currentBillingManifest.totalDiscount)} off your first month` : 'discount applied'}</span>
                    <button className={classes.promoRemoveBtn} onClick={handleRemovePromo} type="button">Remove</button>
                </div>
            ) : (
                <>
                    <div className={classes.promoRow}>
                        <TextField
                            variant="outlined"
                            size="small"
                            fullWidth
                            className={classes.textField}
                            type="text"
                            placeholder="HAVE A PROMO CODE?"
                            value={form.promo}
                            onChange={(e) => setField('promo', e.target.value.toUpperCase())}
                            onKeyDown={(e) => e.key === 'Enter' && handleApplyPromo()}
                            inputProps={{ 'aria-label': 'Promo code' }}
                        />
                        <button
                            className={classes.promoApplyBtn}
                            onClick={handleApplyPromo}
                            type="button"
                            disabled={!form.promo.trim()}
                        >
                            APPLY
                        </button>
                    </div>
                    {form.promoError && (
                        <p className={classes.promoError} role="alert">{form.promoError}</p>
                    )}
                </>
            )}
        </div>
    );
}

PromoCode.propTypes = {
    form: PropTypes.shape({
        promo: PropTypes.string,
        promoApplied: PropTypes.bool,
        promoError: PropTypes.string,
        manifest: PropTypes.object,
    }).isRequired,
    setField: PropTypes.func.isRequired,
    handleApplyPromo: PropTypes.func.isRequired,
    handleRemovePromo: PropTypes.func.isRequired,
    formatPrice: PropTypes.func.isRequired,
};

export default PromoCode;
